import {
  AUTH_ERROR_CODES,
  AUTH_ERROR_MESSAGES,
  AUTH_NAME_MAX_LENGTH,
  AUTH_NAME_MIN_LENGTH,
} from '../authRegistrationConstants'

/** Same family as live storefront email pattern (ASCII, practical). */
const EMAIL_SYNTAX = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i

function validateRequiredPersonName(raw, errorCode) {
  const value = String(raw || '').trim()
  if (value.length < AUTH_NAME_MIN_LENGTH || value.length > AUTH_NAME_MAX_LENGTH) {
    return {
      ok: false,
      errorCode,
      message: AUTH_ERROR_MESSAGES[errorCode],
    }
  }
  return { ok: true, value }
}

/**
 * @param {string} raw
 * @returns {{ ok: true, name: string } | { ok: false, errorCode: string, message: string }}
 */
export function validateRegistrationName(raw) {
  const result = validateRequiredPersonName(raw, AUTH_ERROR_CODES.INVALID_NAME)
  if (!result.ok) return result
  return { ok: true, name: result.value }
}

/**
 * @param {string} raw
 * @returns {{ ok: true, lastName: string } | { ok: false, errorCode: string, message: string }}
 */
export function validateRegistrationLastName(raw) {
  const result = validateRequiredPersonName(raw, AUTH_ERROR_CODES.INVALID_LAST_NAME)
  if (!result.ok) return result
  return { ok: true, lastName: result.value }
}

/**
 * Optional for registration completion. Trim + lowercase + basic syntax when provided.
 * Does NOT imply ownership (emailVerified).
 * @param {string} raw
 * @returns {{ ok: true, email: string } | { ok: false, errorCode: string, message: string }}
 */
export function validateRegistrationEmail(raw) {
  const email = String(raw || '')
    .trim()
    .toLowerCase()
  if (email && !EMAIL_SYNTAX.test(email)) {
    return {
      ok: false,
      errorCode: AUTH_ERROR_CODES.INVALID_EMAIL,
      message: AUTH_ERROR_MESSAGES[AUTH_ERROR_CODES.INVALID_EMAIL],
    }
  }
  return { ok: true, email }
}
